import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      background: palette.background.box,
      borderRadius: palette.borderRadius.default,
      boxShadow: palette.shadows.boxShadow,
      fontFamily: 'montserrat',
      fontWeight: 600,
      color: palette.text.secondary,
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      overflow: 'hidden',
      zIndex: 0
    },
    default: {
      gap: '20px',
      padding: '20px'
    },
    small: {
      gap: '15px',
      padding: '15px'
    },
    mobileTab: {
      gap: '10px',
      padding: '20px',
      marginBottom: '20px'
    },
    dashboardChart: {
      padding: '20px',
      '@media (max-width: 1279px)': {
        height: '100%',
        '& canvas': {
          maxHeight: '300px'
        }
      },
      '@media (max-width: 450px)': {
        padding: '20px'
      }
    },
    background: {
      position: 'absolute',
      height: '190px',
      right: '0',
      bottom: '0',
      zIndex: -1
    },
    infoButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute'
    },
    bottomRight: {
      right: '10px',
      bottom: '5px'
    },
    topRight: {
      right: '10px',
      top: '5px'
    },
    bottomMiddle: {
      position: 'static'
    },
    paddingbottomRight: {
      paddingBottom: '50px'
    },
    paddingtopRight: {
      paddingTop: '50px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
